module.exports = __webpack_public_path__ + "img/background-2.79401e5a.png";